module.exports = __webpack_public_path__ + "img/service1@2x.85e12476.png";